import Image from 'next/image';
import React from 'react';
import Carousel from 'react-multi-carousel';
import { Asset } from '../../../typescript/generated/codegen';

enum DEVICES {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

interface HeroBannerCarouselProps {
  images: Asset[];
}

const HeroBannerCarousel: React.FC<HeroBannerCarouselProps> = ({ images }) => {
  const responsive = {
    [DEVICES.mobile]: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 16,
    },
    [DEVICES.tablet]: {
      breakpoint: { max: 1024, min: 640 },
      items: 1,
      partialVisibilityGutter: 48,
    },
    [DEVICES.desktop]: {
      breakpoint: { max: 9999999, min: 1024 },
      items: 1,
      partialVisibilityGutter: 72,
    },
  };

  const CustomRightArrow = ({ onClick }: any) => {
    // @TODO hide on mobile/tablet
    // const { deviceType } = carouselState;

    return (
      <div
        onClick={() => onClick()}
        className="absolute right-0 z-10 w-20 h-20 cursor-pointer top-1/2 hover:text-accent-hover"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          width="100%"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeWidth={1} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    );
  };

  return (
    <div className="absolute object-cover w-full h-full">
      <Carousel
        responsive={responsive}
        partialVisible
        draggable
        swipeable
        infinite
        removeArrowOnDeviceType={[DEVICES.mobile, DEVICES.tablet]}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<div />}
      >
        {images.map(image => (
          <Image
            width={image.width}
            height={image.height}
            key={image.url}
            src={`${image.url}?w=1600&q=90`}
            alt={image.title}
            className="object-cover w-full h-full pointer-events-none select-none"
          />
        ))}
      </Carousel>
    </div>
  );
};

export default HeroBannerCarousel;
